import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IGetBriefInfluencersV2Response } from "@shared/lib/types/briefInfluencerV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_INFLUENCER_V2_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

interface SearchParams {
  influencerId?: string;
  socialMediaObjectIds?: string[];
  brandIds?: string[];
  mainStatus?: string[];
  socialMediaId?: string;
}

export function useGetBriefsByInfId({
  influencerId,
  socialMediaObjectIds,
  brandIds,
  mainStatus,
  socialMediaId,
}: SearchParams) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBriefInfluencersV2Response>
  >({
    queryKey: [
      ...BRIEF_INFLUENCER_V2_QUERY_KEY,
      influencerId,
      socialMediaId ? [socialMediaId] : socialMediaObjectIds,
      brandIds,
      mainStatus,
    ],
    queryFn: () =>
      BriefService.getBriefInfluencerV2InfId(
        influencerId,
        socialMediaId ? [socialMediaId] : socialMediaObjectIds,
        brandIds,
        mainStatus
      ),
    enabled:
      !!influencerId ||
      !!socialMediaId ||
      !!(socialMediaObjectIds && socialMediaObjectIds.length > 0),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefInfluencers: data?.data,
    isFetching: isLoading,
    isError,
  };
}
